import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { Redirect } from 'react-router-dom';
import NetworkHeartService from 'network-heart-service';
import { Toast } from 'react-bootstrap';
import { last, toNumber } from 'lodash';
import moment from 'moment';


import { getToken } from '../../../../api/get_token';
import { getNRWTable } from '../../../../api/nrw_table';
import Snipper from '../../../layout/Spinner/snipper.component';
import iconRealLoss from './water.svg';
import iconNRWTable from './spreadsheet.svg';
import './map-esri.style.css';


const { REACT_APP_BASE_DOMAIN_GIS_SERVER,
    REACT_APP_BASE_URL_GIS_SERVER,
    REACT_APP_PORTAL_URL_GIS_SERVER,
    REACT_APP_PROXY_URL } = window['runConfig'];

export class MapEsri extends Component {
    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        this.state = {
            dataNRWByDMA: {},
            loading: false,
            hasData: true,
            showToast: false,
            textInToast: '',
            failColorToast: '#DCBF85',
            colorToast: '#F5F8DE'
        }
    }

    closeToast = () => this.setState({ showToast: false });

    opentToast = () => this.setState({ showToast: true });

    searchDMAByMonthYearIDDMA = async (monthSearch, yearSearch, dmaID) => {
        //check network status
        const isOnline = await NetworkHeartService.isOnline();
        if (!isOnline) {
            this.setState({ textInToast: 'Oh, may be you went offline, please check you connection!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }

        this.setState({ loading: true });

        const resGetToken = await getToken();
        const token = resGetToken.data.token;
        const whereClause = `DMAID = '${dmaID}' and MONTH = ${monthSearch} and YEAR = ${yearSearch}`;
        const resGetNRWDMA = await getNRWTable(token, whereClause);

        if (!(Array.isArray(resGetNRWDMA.data.layers[0].features) && resGetNRWDMA.data.layers[0].features.length)) {
            this.setState({ hasData: false, loading: false, dataNRWByDMA: {} })
            this.setState({ textInToast: 'No data found!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }

        //assume result from server have many record at the same time, I will get the lastest
        const lastResultObject = last(resGetNRWDMA.data.layers[0].features).attributes;

        this.setState({ loading: false });

        // if (!(resGetNRWDMA.statusText === 'OK')) {
        //     this.setState({ textInToast: 'Oh, something wrong when searching! Please try again!', colorToast: '#DCBF85' })
        //     this.opentToast();
        //     return;
        // }
        return lastResultObject;
    }

    sendDataToParent = (data) => {
        this.props.getDataNRWByDMAFromParent(data);
    }

    sendActiveKey = (key) => {
        this.props.setDefaultActiveKeyTab(key);
    }

    componentDidMount() {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(["esri/identity/OAuthInfo", "esri/identity/IdentityManager", 'esri/portal/Portal', "esri/identity/ServerInfo",
            "esri/config", "esri/core/urlUtils", 'esri/Map', 'esri/WebMap', 'esri/views/MapView', 'esri/widgets/Legend', 'esri/widgets/Expand',
            "esri/layers/FeatureLayer", "esri/Graphic", "esri/PopupTemplate", "esri/widgets/Search",
            ], { css: true })
            .then(([OAuthInfo, esriId, Portal, ServerInfo, esriConfig, urlUtils, ArcGISMap, WebMap, MapView, Legend,
                Expand, FeatureLayer, Graphic, PopupTemplate, Search]) => {

                //*TODO: proxy config
                // esriConfig.request.proxyUrl = "https://www.thodev.localhost.com/DotNet/proxy.ashx";
                // esriConfig.request.proxyUrl = `${REACT_APP_PROXY_URL}`;

                
                //intelli server
                // urlUtils.addProxyRule({
                //     urlPrefix: `${REACT_APP_BASE_DOMAIN_GIS_SERVER}`,
                //     proxyUrl: `${REACT_APP_PROXY_URL}` 
                // });

                //*TODO: server info
                let serverInfo = new ServerInfo();
                serverInfo.hasPortal = true;
                serverInfo.server = `${REACT_APP_PORTAL_URL_GIS_SERVER}`;//"https://gis.exxor.com.my/portal";
                serverInfo.tokenServiceUrl = `${REACT_APP_PORTAL_URL_GIS_SERVER}/sharing/rest/generateToken` ;//'https://gis.exxor.com.my/portal/sharing/rest/generateToken';
                let userInfo = { username: "intelli", password: "Intelli@2020" };

                //*TODO: generate token
                esriId.generateToken(serverInfo, userInfo).then(function (data) {
                    // This is called when the promise resolves
                    var tokenValue = data.token;
                    // Register Token, after registration, all resources in the Portal, as long as the user is accessed by the permission, can be used directly, all previous security service requests will send the token value as a parameter to the server
                    esriId.registerToken({ server: `${REACT_APP_PORTAL_URL_GIS_SERVER}`, token: tokenValue });
                }, function (error) {
                    // This function is called when the promise is rejected
                    console.error(error);  // Logs the error message
                });

                //*TODO: create webmap
                const webMap = new WebMap({
                    portalItem: {
                        id: "36a1d004025d4693bd2602714bf80558",
                        portal: `${REACT_APP_PORTAL_URL_GIS_SERVER}`
                    }
                });

                //*TODO: create view to show map
                this.view = new MapView({
                    container: this.mapRef.current,
                    map: webMap,
                });

                //*TODO: use if needed to do something when view done loading
                this.view.when(() => {
                    // This function will execute once the promise is resolved
                    // console.log('webMap:', JSON.stringify(this.view.map.tables));
                    let popup = this.view.popup;
                    popup.viewModel.on("trigger-action", async (event) => {
                        let attributes = popup.viewModel.selectedFeature.attributes;
                        let dmaid = attributes.DMAID;
                        let month = attributes.MONTH;
                        let year = attributes.YEAR;
                        if (event.action.id === "real-loss") {
                            // Get the 'website' field attribute
                            // var info = attributes.website;
                            // // Make sure the 'website' field value is not null
                            // if (info) {
                            //     // Open up a new browser using the URL value in the 'website' field
                            //     window.open(info.trim());
                            // }
                            // console.log('trigger action real-loss: ',attributes.DMANAME);
                            this.searchDMAByMonthYearIDDMA(month, year, dmaid).then((res) => {
                                let dataNRWByDMA = {
                                    data: res,
                                    MONTH: month,
                                    YEAR: year,
                                    DMAID: dmaid
                                }

                                this.sendDataToParent(dataNRWByDMA);
                                this.sendActiveKey('realloss');
                            });
                            // <Redirect to="/dashboard" /> 
                        }

                        if (event.action.id === "water-balance") {
                            // Get the 'website' field attribute
                            // var info = attributes.website;
                            // // Make sure the 'website' field value is not null
                            // if (info) {
                            //     // Open up a new browser using the URL value in the 'website' field
                            //     window.open(info.trim());
                            // }
                            // console.log('trigger action water-balance: ',attributes.DMANAME);

                            this.searchDMAByMonthYearIDDMA(month, year, dmaid).then((res) => {
                                // console.log('lastResultObject: ', res)
                                let dataNRWByDMA = {
                                    data: res,
                                    MONTH: month,
                                    YEAR: year,
                                    DMAID: dmaid
                                }
                                this.sendDataToParent(dataNRWByDMA);
                                this.sendActiveKey('waterbalancetable');
                            });
                        }
                    });
                }, function (error) {
                    // This function will execute if the promise is rejected due to an error
                });

                //*TODO: create action button to add to popup
                // Removes the zoom action on the popup
                this.view.popup.actions = [];
                let goRealLoosAction = {
                    // This text is displayed as a tooltip
                    title: "Real loss",
                    // The ID by which to reference the action in the event handler
                    id: "real-loss",
                    // Sets the icon font used to style the action button
                    // className: "esri-icon-zoom-out-magnifying-glass"
                    image: iconRealLoss
                };
                let goNRWTable = {
                    // This text is displayed as a tooltip
                    title: "Water balance",
                    // The ID by which to reference the action in the event handler
                    id: "water-balance",
                    // Sets the icon font used to style the action button
                    // className: "esri-icon-zoom-out-magnifying-glass"
                    image: iconNRWTable
                };
                // Adds the custom action to the popup.
                this.view.popup.viewModel.actions.push(goRealLoosAction);
                this.view.popup.viewModel.actions.push(goNRWTable);

                //*TODO: do something when user click on view
                // this.view.on("click", (event) => {
                //     // you must overwrite default click-for-popup
                //     // behavior to display your own popup
                //     this.view.popup.autoOpenEnabled = true;

                //     this.view.popup.fetchFeatures(event.screenPoint).then(function (response) {
                //         // Access the response from fetchFeatures
                //         response.allGraphicsPromise.then(function (graphics) {
                //             // Set the feature widget's graphic to the returned graphic from fetchFeatures
                //             console.log('vao day:', JSON.stringify(graphics[0].attributes.DMANAME));
                //             // featureWidget.graphic = graphics[0];
                //         });
                //     });
                // });

                //*TODO: add lengend
                const legend = new Expand({
                    content: new Legend({
                        view: this.view,
                        style: "classic", // other styles include 'classic' //
                    }),
                });
                this.view.ui.add(legend, "bottom-left");

                //*TODO: add search
                const searchWidget = new Search({
                    view: this.view
                });
                // Adds the search widget below other elements in
                // the top left corner of the view
                this.view.ui.add(searchWidget, {
                    position: "top-left",
                    index: 0
                });

                
               
            });
    }

    componentWillUnmount() {
        if (this.view) {
            // destroy the map view
            this.view.container = null;
        }
    }

    render() {
        return (
            <div>
                {/* {this.state.redirect ? <Redirect to={{
                    pathname: this.state.goTo,
                    state: this.state.dataNRWByDMA
                }} /> : <div className="webmap" ref={this.mapRef} />} */}

                <div className="webmap" ref={this.mapRef} />

                <div style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '2px',
                }}>
                    <Toast onClose={this.closeToast} show={this.state.showToast} delay={3000} autohide>
                        <Toast.Header>
                            <img
                                src="holder.js/20x20?text=%20"
                                className="rounded mr-2"
                                alt=""
                            />
                            <strong className="mr-auto">NRW Management</strong>
                            {/* <small>11 mins ago</small> */}
                        </Toast.Header>
                        <Toast.Body style={{ backgroundColor: `${this.state.colorToast}` }}>{this.state.textInToast}</Toast.Body>
                    </Toast>
                </div>

                {this.state.loading ?
                    (<div style={{
                        position: 'fixed',
                        top: '50%',
                        right: '50%',
                    }}>
                        <Snipper /></div>) : (<></>)}
            </div>
        );

    }
}

export default MapEsri
